import type { TypeBadgeCellRendererProps } from '@thefarmersfront/kitchen';

import { BadgeCell } from '~/components/common';

type TypeBadgeColor = NonNullable<TypeBadgeCellRendererProps['colorMap'][string]>['color'];

type TypeStatusBadgeProps = Omit<TypeBadgeCellRendererProps, 'value' | 'colorMap'> & {
  value: { code: string; description: string };
  colors: Partial<Record<string, TypeBadgeColor>>;
  /** 설명이 비면 '-' 를 라벨로 보인다. @default true */
  dashIfNoLabel?: boolean;
};

/** 여러 값을 ', ' 로 잇는다. 빈 값은 건너뛰고(채번 전 운송장번호 등), 남는 값이 없으면 '-'. */
export const joinOrDash = (value?: string[] | null) => {
  const values = value?.filter(Boolean) ?? [];
  return values.length ? values.join(', ') : '-';
};

/** 여러 줄로 늘어나는 칸이 있는 표에서, 짧은 칸은 첫 줄 높이(40px)에 맞춰 위에 둔다. */
export const FIRST_LINE_CELL_STYLE = { verticalAlign: 'top', paddingTop: 6 } as const;

/** 코드·설명 응답을 뱃지 하나로 그린다. 라벨은 응답의 설명을 그대로 쓰고, 색은 코드로 고른다. */
export const StatusBadge = ({
  value,
  colors,
  dashIfNoLabel = true,
  variant = 'light',
  status = true,
  ...badgeProps
}: TypeStatusBadgeProps) => (
  <BadgeCell
    value={value.code}
    colorMap={{
      [value.code]: {
        label: dashIfNoLabel ? value.description || '-' : value.description,
        color: colors[value.code],
      },
    }}
    variant={variant}
    status={status}
    {...badgeProps}
  />
);
